import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { RewardPoints } from '@/models/loyalty';
import { Reward } from '@/models';

@Component({
  name: 'CmgLoyaltyProgressBar',
})
export default class CmgLoyaltyProgressBar extends Vue {
  @Prop({ type: String, required: false, default: '' })
  customMessage?: string;

  @Prop({ type: Boolean, required: false, default: false })
  hideMessage?: boolean;

  @Prop({ type: Boolean, required: false, default: false })
  animateProgress?: boolean;

  get points(): RewardPoints | null {
    return this.$appStore.state.customer.rewardPoints;
  }

  get message(): string {
    if (this.hideMessage) {
      return '';
    } else if (this.customMessage) {
      return this.customMessage;
    } else if (this.progressPercentage < 100) {
      return 'Keep earning to unlock your favorite';
    } else {
      return 'You unlocked your favorite reward';
    }
  }

  get progressPercentage(): number {
    return this.$services.reward.getProgressPercentage();
  }

  get favoritedReward(): Reward | undefined {
    return this.$services.reward.getFavoriteReward();
  }

  get messageClassObject() {
    return { unlocked: this.progressPercentage >= 100 };
  }
}
